export default __webpack_public_path__ + "static/media/V550_RoHS.acc6444c.pdf";